import React from 'react';

const MessageFormatter = ({ content, isUser = false }) => {
  // Simple formatter to handle basic text formatting
  const formatMessage = (text) => {
    if (!text) return '';

    // Handle line breaks
    const lines = text.split('\n');

    return lines.map((line, index) => {
      // Handle URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = line.split(urlRegex);

      const formattedLine = parts.map((part, partIndex) => {
        if (urlRegex.test(part)) {
          return (
            <a
              key={`${index}-${partIndex}`}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className={`underline ${isUser ? 'text-inherit' : 'text-primary'}`}
            >
              {part}
            </a>
          );
        }

        // Handle bold text **text**
        if (part.includes('**')) {
          const boldRegex = /\*\*(.*?)\*\*/g;
          const boldParts = part.split(boldRegex);

          return boldParts.map((boldPart, boldIndex) => {
            if (boldIndex % 2 === 1) {
              return (
                <span
                  key={`${index}-${partIndex}-${boldIndex}`}
                  className="font-bold"
                >
                  {boldPart}
                </span>
              );
            }
            return boldPart;
          });
        }

        // Handle code blocks `code`
        if (part.includes('`')) {
          const codeRegex = /`(.*?)`/g;
          const codeParts = part.split(codeRegex);

          return codeParts.map((codePart, codeIndex) => {
            if (codeIndex % 2 === 1) {
              return (
                <span
                  key={`${index}-${partIndex}-${codeIndex}`}
                  className={`font-mono px-1 py-0.5 rounded text-[0.85em] ${
                    isUser ? 'bg-white/20' : 'bg-muted/80'
                  }`}
                >
                  {codePart}
                </span>
              );
            }
            return codePart;
          });
        }

        return part;
      });

      return (
        <React.Fragment key={index}>
          {formattedLine}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="text-sm whitespace-pre-wrap break-words leading-relaxed">
      {formatMessage(content)}
    </div>
  );
};

export default MessageFormatter;
